/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState, useCallback } from 'react';
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Text,
  Spinner,
  Divider,
  Button,
  HStack,
} from '@chakra-ui/react';
import { useAppSelector } from '../../../utils/reduxHooks';
import { RootState } from '../../../store/store';
import { FiltersProductCard } from './filtersProductCard';
import { useParams } from 'react-router-dom';

const ITEMS_PER_PAGE = 10; // Количество элементов на одной странице

export const FiltersProductTable: React.FC = () => {
  const { searchText } = useParams();
  const searchSuppliers = useAppSelector((state: RootState) => state.carts.serchDetailsBySuppliers);
  const isLoading = useAppSelector(
    (state: RootState) => state.carts.isLoading.serchDetailsBySuppliers,
  );

  const [currentPage, setCurrentPage] = useState(1); // Текущая страница
  const external = searchSuppliers?.external || [];
  const original = searchSuppliers?.items || [];
  const combinedItems = [...original, ...external];

  console.log(external, 'FiltersProductTable external');
  console.log(original, 'FiltersProductTable original');

  // Преобразуем данные в ожидаемый формат
  const transformToProduct = (supplier: any) => ({
    id: supplier.pk || '',
    supplierId: supplier.supplier_id || '',
    brand: supplier.brand || 'Неизвестно',
    brand_article: supplier.brand_article || '—',
    name: supplier.name || 'Без названия',
    amount: supplier.amount || 0,
    delivery_term: supplier.delivery_term || -1,
    price: supplier.price || 0,
  });

  const transformedItems = combinedItems.map(transformToProduct);

  // Группировка по бренду
  const groupByBrand = (products: any[]) => {
    return products.reduce((groups: Record<string, any[]>, product) => {
      if (!groups[product.brand]) {
        groups[product.brand] = [];
      }
      groups[product.brand].push(product);
      return groups;
    }, {});
  };

  const groupedItems = groupByBrand(transformedItems);

  // Получение всех групп в виде массива
  const allGroups: any = Object.entries(groupedItems); // [['Brand1', [product1, product2]], ['Brand2', [...]]]

  // Подсчёт общего количества элементов
  const totalItems = allGroups.reduce((sum, [, products]) => sum + products.length, 0);

  // Пагинация: распределение групп по страницам
  const getPaginatedGroups = (
    groups: [string, any[]][],
    page: number,
    itemsPerPage: number,
  ): [string, any[]][] => {
    const startIndex = (page - 1) * itemsPerPage;
    let currentCount = 0;

    return groups.reduce((result: [string, any[]][], [brand, products]) => {
      if (currentCount >= startIndex + itemsPerPage) return result;

      const remainingSpace = Math.max(startIndex + itemsPerPage - currentCount, 0);
      const groupProducts =
        currentCount + products.length > startIndex
          ? products.slice(Math.max(startIndex - currentCount, 0), remainingSpace)
          : [];

      if (groupProducts.length > 0) {
        result.push([brand, groupProducts]);
        currentCount += groupProducts.length;
      } else {
        currentCount += products.length;
      }

      return result;
    }, []);
  };

  const paginatedGroups = getPaginatedGroups(allGroups, currentPage, ITEMS_PER_PAGE);

  // Всего страниц
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);

  // Если данные загружаются
  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" p={6}>
        <Spinner size="xl" />
      </Box>
    );
  }

  // Если данные отсутствуют
  if (totalItems === 0) {
    return (
      <Box p={6} textAlign="center">
        <Text fontSize="lg" color="gray.500">
          Нет товаров, соответствующих вашему запросу
        </Text>
      </Box>
    );
  }

  return (
    <Box border="1px solid" borderColor="gray.200" borderRadius="md" overflow="hidden">
      <Text fontSize="xl" fontWeight="bold" p={4} borderBottom="1px solid" borderColor="gray.200">
        Результаты поиска {searchText}
      </Text>

      {paginatedGroups.map(([brand, products]) => (
        <Box key={brand}>
          {/* Заголовок группы */}
          <Text fontSize="lg" fontWeight="bold" p={4}>
            {brand}
          </Text>
          <Table variant="simple">
            <Thead bg="gray.100">
              <Tr>
                <Th whiteSpace="nowrap">Производитель, артикул</Th>
                <Th>Наименование</Th>
                <Th isNumeric>Наличие</Th>
                <Th whiteSpace="nowrap">Срок поставки</Th>
                <Th isNumeric>Цена</Th>
                <Th></Th>
              </Tr>
            </Thead>
            <Tbody>
              {products.map((product, idx) => (
                <FiltersProductCard key={`item-${brand}-${idx}`} product={product} />
              ))}
            </Tbody>
          </Table>
          <Divider my={4} />
        </Box>
      ))}

      {/* Пагинация */}
      <HStack justifyContent="center" mt={4} spacing={2}>
        <Button
          size="sm"
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          isDisabled={currentPage === 1}
        >
          Назад
        </Button>
        <Text fontSize="sm">
          Страница {currentPage} из {totalPages}
        </Text>
        <Button
          size="sm"
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          isDisabled={currentPage === totalPages}
        >
          Вперед
        </Button>
      </HStack>
      <Divider my={4} />
    </Box>
  );
};
